import React, { Component } from 'react';

class Consent extends Component {
  handleConsentChkChang (event) {
    if (event.currentTarget.checked) {
      setTimeout(() => {
        document.querySelector('.re_visual_image_gift').scrollIntoView(false);
      }, 503);
    }
  }

  render () {
    return (
      <div className='re_consent_w'>
        <h4 className='hide'>개인정보 수집 및 이용 동의</h4>
        <fieldset>
          <legend className='hide'>개인정보 수집 및 이용 동의 입력 영역</legend>
          <div className='module_terms_w'>
            <div className='module_terms_info_w'>
              <span className='mti_tit'><strong className='mti_point'>{this.props.userId}님</strong>의 기본 정보를 다시 한 번 확인 해주세요.</span>
              <span className='mti_txt'>정보를 수정 하시려면 정보수정을 클릭하세요.</span>
              <a className='mti_link' href='//join.sbs.co.kr/myzone/myzoneUserInfo.do?menuId=0401&pwchk=true'>정보수정<span className='roulette_icn icon_bluearrow'><i className='ir'>화살표</i></span></a>
            </div>
            <div className='module_terms_box_w'>
              <div className='mtb_inner'>
                <strong className='mtb_title'>개인 정보 제공 동의</strong>
                <div className='mtb_text_w'>
                  <div className='mtbt_row'>
                    <div className='mtbtr_inner'>
                      <strong className='mtbt_tit'>개인정보를 제공받는 자</strong>
                      <span className='mtbt_txt'>{this.props.currentEventInfo !== null ? this.props.currentEventInfo.eventInfo.psnClcSbj : ''}</span>
                    </div>
                    <div className='mtbtr_inner'>
                      <strong className='mtbt_tit'>개인정보를 제공받는 자의 개인정보 이용 목적</strong>
                      <span className='mtbt_txt'>{this.props.currentEventInfo !== null ? this.props.currentEventInfo.eventInfo.psnUseInt : ''}</span>
                    </div>
                  </div>
                  <div className='mtbt_row'>
                    <div className='mtbtr_inner'>
                      <strong className='mtbt_tit'>제공하는 개인정보의 항목</strong>
                      <span className='mtbt_txt'>{this.props.currentEventInfo !== null ? this.props.currentEventInfo.eventInfo.psnOfferLst : ''}</span>
                    </div>
                    <div className='mtbtr_inner'>
                      <strong className='mtbt_tit'>개인정보를 제공받는 자의 개인정보 보유 및 이용기간</strong>
                      <span className='mtbt_txt'>{this.props.currentEventInfo !== null ? this.props.currentEventInfo.eventInfo.psnRetTrm : ''}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className='module_terms_checkbox_w'>
              <input
                id='consentChk' className='mtc_checkbox_input' type='checkbox'
                onChange={this.handleConsentChkChang}
              />
              <label className='mtc_checkbox_label' htmlFor='consentChk'>
                <span className='mtc_checkbox'>
                  <i className='roulette_icn icon_check' />
                </span>
                <strong className='mtc_checkbox_text'>개인정보 수집 및 이용에 동의합니다.</strong>
              </label>
            </div>
          </div>
        </fieldset>
      </div>
    );
  }
}

export default Consent;
